document.addEventListener('DOMContentLoaded', function () {

  var tries = 0;
  var maxTries = 60; // ~18s

  var interval = setInterval(function () {
    tries++;

    var calc = document.querySelector('[id*="shipping_rates_calc_calculator"]');
    var paymentBtns = document.querySelector('.product-single__form .payment-buttons');

    if (calc && paymentBtns) {

      if (paymentBtns.parentNode) {

        // ⬇️ UPDATED: insert AFTER payment-buttons
        paymentBtns.insertAdjacentElement('afterend', calc);

        // Add class
        calc.classList.add('znt--moved-up');

        // Wait for the internal panel to load, then click automatically
        waitForOCTPanelAndClick();
      }

      clearInterval(interval);
      return;
    }

    if (tries >= maxTries) {
      clearInterval(interval);
    }

  }, 300);


  // --- NEW FUNCTION BELOW ---
  function waitForOCTPanelAndClick() {
    var tries = 0;
    var maxTries = 40;

    var check = setInterval(function () {
      tries++;

      var panel = document.querySelector('.oct-calculator-form-container');

      if (panel) {
        var trigger = document.querySelector('.oct-calculator-open');
        if (trigger) {
          trigger.click();
        }
        clearInterval(check);
        return;
      }

      if (tries >= maxTries) {
        clearInterval(check);
      }

    }, 300);
  }

});



// Cart page 
document.addEventListener('DOMContentLoaded', function () {

  var tries = 0;
  var maxTries = 60; // ~18s

  var interval = setInterval(function () {
    tries++;

    var calc = document.querySelector('[id*="shipping_rates_calc_calculator"]');
    var subtotalRow = document.querySelector('.cart__page-col .cart__item-row.cart__item--subtotal');

    if (calc && subtotalRow) {

      if (subtotalRow.parentNode) {

        // Insert AFTER the subtotal row (inside .cart__page-col)
        subtotalRow.insertAdjacentElement('afterend', calc);

        // Add class (optional cosmetic)
        calc.classList.add('znt--moved-up');

        // Wait for panel then click
        waitForOCTPanelAndClick();
      }

      clearInterval(interval);
      return;
    }

    if (tries >= maxTries) {
      clearInterval(interval);
    }

  }, 300);


  // Wait for OCT shipping panel to load, then click
  function waitForOCTPanelAndClick() {
    var tries = 0;
    var maxTries = 40;

    var check = setInterval(function () {
      tries++;

      var panel = document.querySelector('.oct-calculator-form-container');

      if (panel) {
        var trigger = document.querySelector('.oct-calculator-open');
        if (trigger) {
          trigger.click();
        }
        clearInterval(check);
        return;
      }

      if (tries >= maxTries) {
        clearInterval(check);
      }

    }, 300);
  }

});
